var map = {
	"./carbon--directory-domain.svg": 1948,
	"./carbon--tcp-ip-service.svg": 8404,
	"./clarity--backup-solid.svg": 7416,
	"./cryptocurrency--ppc.svg": 572,
	"./eos-icons--dns.svg": 4444,
	"./fluent--desktop-edit-20-regular.svg": 5040,
	"./fluent--tasks-app-28-regular.svg": 156,
	"./gala--display-eye.svg": 7584,
	"./gala--display-reaload.svg": 6036,
	"./healthicons--desktop-app-outline.svg": 3672,
	"./icon-park-outline--download-computer.svg": 6768,
	"./icon-park-outline--permissions.svg": 3460,
	"./icon-park-outline--setting-computer.svg": 8508,
	"./mage--reload.svg": 9492,
	"./material-symbols--folder-data-outline.svg": 8104,
	"./material-symbols--health-metrics-outline-rounded.svg": 3844,
	"./mdi--account-wrench.svg": 8543,
	"./mdi--domain.svg": 7040,
	"./mdi--ip-network-outline.svg": 3181,
	"./mdi--shield-user.svg": 9048,
	"./streamline--customer-support-1.svg": 55,
	"./streamline--printer.svg": 4532,
	"./tabler--cloud-upload.svg": 2404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 276;